'use strict';

angular.module('far.models.mountains.peaks', [])
    .service('mountainPeaks', function ($log, $http, $q) {
        this.getByArea = function (area_id) {
            return $http.get(Routing.generate('api_entities_get_mountainpeak', {mountainArea: area_id}))
                .then(function (response) {
                    return response.data;
                }, function (response) {
                    $q.reject(response);
                    $log.error(response);
                });
        };

        this.new = function (mountainPeakData) {
            return new MountainPeak(mountainPeakData);
        };

        this.get = function (id, callback) {
            var mountainPeak = new MountainPeak({});

            $http.get(Routing.generate('api_get_mountain_peak', {mountainPeak: id}))
                .then(function (response) {
                    mountainPeak.update(response.data);

                    if (typeof callback == 'function') {
                        callback(mountainPeak);
                    }
                }, function (response) {
                    $q.reject(response);
                    $log.error(response);
                });

            return mountainPeak;
        };

        this.delete = function (mountainPeak, callback) {
            return $http.delete(Routing.generate('api_delete_mountain_peak', {mountainPeak: mountainPeak.id}))
                .then(function () {
                    mountainPeak = null;

                    if (typeof callback == 'function') {
                        callback();
                    }
                })
                .catch(function (response) {
                    $log.error(response);
                });
        };

        this.restore = function (region, callback) {
            return $http.patch(Routing.generate('api_patch_mountain_peak', {id: region.id}))
                .then(function () {
                    if (typeof callback == 'function') {
                        callback();
                    }
                })
                .catch(function (response) {
                    $log.error(response);
                });
        };

        function MountainPeak(mountainPeakData) {
            angular.merge(this, mountainPeakData);

            Object.defineProperty(this, 'update', {
                enumerable: false,
                get: function () {
                    return function (mountainPeakData) {
                        angular.merge(this, mountainPeakData);
                    }
                }
            });

            Object.defineProperty(this, 'save', {
                enumerable: false,
                get: function () {
                    return function () {
                        var method = this.id ? 'put' : 'post',
                            url = this.id ?
                                Routing.generate('api_put_mountain_peak', {mountain_peak: this.id}) :
                                Routing.generate('api_post_mountain_peak');

                        var data = angular.merge({}, this);

                        data.mountainArea = data.mountain_area;

                        delete data.mountain_area;

                        return $http[method](url, data);
                    }
                }
            });
        }
    });